import { createSelector } from '@ngrx/store';
import { FilteredClientAccount } from '@shared/models';
import { getFeatureToggleState, getInternalTransferState } from '@store/reducers';
import { FeatureToggleState } from '@store/reducers/feature/feature.reducer';
import { InternalTransferState } from '@store/reducers/internal-transfer/internal-transfer.reducer';
import { selectEligibleInternalTransferToAccounts } from '@store/selectors/client-accounts/client-accounts.selectors';
import { selectVCDSettlementFundsToggle } from '@store/selectors/feature/feature.selectors';

import { nullState } from '../common/router.selectors';
import {
  getDivorceDocUploadNextPage,
  getDivorceReviewHoldingsNextPage,
  getDivorceReviewNextPage,
  getDivorceTermsNextPage,
  getInternalTransferContactInfoNextPage,
  getInternalTransferCostBasisOptInNextPage,
  getInternalTransferDetailsNextPage,
  getInternalTransferDifferentOwnersNextPage,
  getInternalTransferEmploymentNextPage,
  getInternalTransferFromNextPage,
  getInternalTransferHoldingsReviewNextPage,
  getInternalTransferIncomeNetWorthNextPage,
  getInternalTransferInvestObjNextPage,
  getInternalTransferOpenAccountNextPage,
  getInternalTransferOverviewNextPage,
  getInternalTransferPersonalInfoNextPage,
  getInternalTransferReviewNextPage,
  getInternalTransferSettlementFundNextPage,
  getInternalTransferTermsExistingNextPage,
  getInternalTransferTermsNewNextPage,
  getInternalTransferToNextPage,
  getInternalTransferTriageNextPage,
} from './internal-transfer-router.helpers';

export const selectInternalTransferOverviewNextPage = createSelector(nullState, () =>
  getInternalTransferOverviewNextPage(),
);

export const selectInternalTransferTriageNextPage = createSelector(nullState, () =>
  getInternalTransferTriageNextPage(),
);

export const selectInternalTransferToNextPage = createSelector(
  getInternalTransferState,
  (internalTransfer: InternalTransferState) => getInternalTransferToNextPage(internalTransfer),
);

export const selectInternalTransferFromNextPage = createSelector(nullState, () =>
  getInternalTransferFromNextPage(),
);

export const selectInternalTransferDetailsNextPage = createSelector(nullState, () =>
  getInternalTransferDetailsNextPage(),
);

export const selectInternalTransferHoldingsReviewNextPage = createSelector(
  selectEligibleInternalTransferToAccounts,
  getInternalTransferState,
  getFeatureToggleState,
  (
    eligibleInternalTransferToAccounts: FilteredClientAccount,
    internalTransfer: InternalTransferState,
    featureToggle: FeatureToggleState,
  ) =>
    getInternalTransferHoldingsReviewNextPage(
      eligibleInternalTransferToAccounts,
      internalTransfer,
      featureToggle,
    ),
);

export const selectInternalTransferDifferentOwnersNextPage = createSelector(nullState, () =>
  getInternalTransferDifferentOwnersNextPage(),
);

export const selectInternalTransferOpenAccountNextPage = createSelector(
  getInternalTransferState,
  (internalTransfer: InternalTransferState) =>
    getInternalTransferOpenAccountNextPage(internalTransfer),
);

export const selectInternalTransferPersonalInfoNextPage = createSelector(nullState, () =>
  getInternalTransferPersonalInfoNextPage(),
);
export const selectInternalTransferContactInfoNextPage = createSelector(
  selectVCDSettlementFundsToggle,
  (settlementFundToggle) => getInternalTransferContactInfoNextPage(settlementFundToggle),
);
export const selectInternalTransferSettlementFundNextPage = createSelector(nullState, () =>
  getInternalTransferSettlementFundNextPage(),
);
export const selectInternalTransferEmploymentNextPage = createSelector(nullState, () =>
  getInternalTransferEmploymentNextPage(),
);
export const selectInternalTransferIncomeNetWorthNextPage = createSelector(nullState, () =>
  getInternalTransferIncomeNetWorthNextPage(),
);
export const selectInternalTransferInvestObjNextPage = createSelector(nullState, () =>
  getInternalTransferInvestObjNextPage(),
);

export const selectInternalTransferReviewNextPage = createSelector(
  getInternalTransferState,
  (internalTransfer: InternalTransferState) => getInternalTransferReviewNextPage(internalTransfer),
);

export const selectInternalTransferCostBasisOptInNextPage = createSelector(
  getInternalTransferState,
  (internalTransfer: InternalTransferState) =>
    getInternalTransferCostBasisOptInNextPage(internalTransfer),
);

export const selectInternalTransferTermsExistingNextPage = createSelector(
  getInternalTransferState,
  (internalTransfer: InternalTransferState) =>
    getInternalTransferTermsExistingNextPage(internalTransfer),
);

export const selectInternalTransferTermsNewNextPage = createSelector(nullState, () =>
  getInternalTransferTermsNewNextPage(),
);

export const selectDivorceDocUploadNextPage = createSelector(nullState, () =>
  getDivorceDocUploadNextPage(),
);

export const selectDivorceReviewHoldingsNextPage = createSelector(nullState, () =>
  getDivorceReviewHoldingsNextPage(),
);

export const selectDivorceReviewNextPage = createSelector(nullState, () =>
  getDivorceReviewNextPage(),
);

export const selectDivorceTermsNextPage = createSelector(nullState, () =>
  getDivorceTermsNextPage(),
);
